import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MasterService } from 'src/app/core/services/master.service';
import { ROOT_COMPANY_ID } from 'src/app/shared/constants/constants';

@Injectable({
  providedIn: 'root',
})
export class CustomBreadcrumbService {
  private _activeCrumb = new BehaviorSubject<string>('');

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private masterService: MasterService,
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      let crumb = this.getRouteData(this.route.root);
      crumb = this.applyRoleBasedOverride(crumb);

      if (crumb) {
        this._activeCrumb.next(crumb);
      }
    });
  }

  private getRouteData(route: ActivatedRoute): string | null {
    let breadcrumb = route.snapshot.data['breadcrumb'] || null;
    if (route.firstChild) {
      return this.getRouteData(route.firstChild) || breadcrumb;
    }
    return breadcrumb;
  }

  private applyRoleBasedOverride(defaultCrumb: string | null): string | null {
    const user = this.masterService.getUserDetailFromStorage(); // assume this gives role
    const isAdminUser = user?.companyid == ROOT_COMPANY_ID;
    if (!defaultCrumb) return null;

    if (defaultCrumb && defaultCrumb === 'Department') {
      return isAdminUser ? 'Data Management' : 'Product Management';
    }

    if (defaultCrumb && defaultCrumb === 'Store Group') {
      return isAdminUser ? 'Data Management' : 'Store Management';
    }

       if (defaultCrumb && defaultCrumb === 'Attribute') {
      return isAdminUser ? 'Data Management' : 'Product Management';
    }

    return defaultCrumb;
  }

  get activeCrumbName$() {
    return this._activeCrumb.asObservable();
  }

  getCurrentBreadcrumb(): string {
    return this._activeCrumb.getValue();
  }
}
